module.exports = __webpack_public_path__ + "fonts/FormalScript.ebf26416.otf";